import React from 'react'

interface DueDateInputProps {
  value?: string
  onClick?: () => void
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
  placeholder?: string
}

export const DueDateInput = React.forwardRef<HTMLInputElement, DueDateInputProps>(({ value, onClick, onChange, disabled, placeholder }, ref) => (
  <div className='input-group'>
    <span className='input-group-text' role='button' onClick={onClick}>
      <i className='bi bi-calendar3' />
    </span>
    <input ref={ref} type='text' className='form-control' value={value} onClick={onClick} onChange={onChange} disabled={disabled} placeholder={placeholder} />
    <span className='input-group-text' role='button' onClick={onClick}>
      <i className='bi bi-chevron-expand' />
    </span>
  </div>
))
DueDateInput.displayName = 'DueDateInput'
